import Web3 from 'web3'
import BigNumber from 'bignumber.js'
import { getAddress } from '@ethersproject/address'
import ERC20Json from 'lottery/abi/ERC20.json'
import TokenSaleAbi from 'lottery/abi/tokenSale.json'

import ropstenTokenList from 'lottery/ropsten.json'
import kovanTokenList from 'lottery/kovan.json'
import allTokensList from 'lottery/uniswap_all_tokens_list.json'

const ERC20Abi = ERC20Json.abi

// const networks = {
//   1: 'mainnet',
//   3: 'ropsten',
//   42: 'kovan',
// }

const networkTokenLists = {
  1: ropstenTokenList,
  3: ropstenTokenList,
  42: kovanTokenList,
}

export const allTokens = allTokensList

export const allTokensDict = {}
for (let t of allTokens.tokens) {
  allTokensDict[t.address.toLowerCase()] = t
}

export const env = process.env.REACT_APP_ENV
export const tokenList =
  networkTokenLists[Number(process.env.REACT_APP_CHAIN_ID)]

export const WETH =
  process.env.REACT_APP_CHAIN_ID === '42'
    ? '0xd0A1E359811322d97991E03f863a0C30C2cF029C'.toLowerCase()
    : '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2'.toLowerCase()

export const tokenDict = {}
for (let t of tokenList) {
  tokenDict[t.address.toLowerCase()] = t
}

export const poolsAddress = process.env.REACT_APP_POOLS_ADDRESS
export const tokenAddress = process.env.REACT_APP_TOKEN_ADDRESS

export const getUbetToken = (provider, address) => {
  const web3 = new Web3(provider)
  const contract = new web3.eth.Contract(ERC20Abi, address)
  return contract
}

export const weiToEth = (balance, decimals = 18) => {
  const displayBalance = balance.dividedBy(new BigNumber(10).pow(decimals))
  return displayBalance.toFixed(4)
}

export const ubetToEth = weiToEth

export const getERC20Token = (provider, address) => {
  const web3 = new Web3(provider)
  if (!web3.utils.isAddress(address)) {
    return undefined
  }
  const contract = new web3.eth.Contract(ERC20Abi, address)
  return contract
}

export const getPoolContract = (provider, address = poolsAddress) => {
  const web3 = new Web3(provider)
  const contract = new web3.eth.Contract(TokenSaleAbi, address)
  return contract
}

export const getBalance = async (provider, tokenAddress, userAddress) => {
  const lpContract = getERC20Token(provider, tokenAddress)
  try {
    const balance = await lpContract.methods.balanceOf(userAddress).call()
    return balance
  } catch (e) {
    return '0'
  }
}

const ENS_NAME_REGEX = /^(([a-zA-Z0-9]+\.)+)eth(\/.*)?$/

export const parseENSAddress = (ensAddress) => {
  const match = ensAddress.match(ENS_NAME_REGEX)
  if (!match) return undefined
  return { ensName: `${match[1].toLowerCase()}eth`, ensPath: match[3] }
}

export const isAddress = (value) => {
  try {
    return getAddress(value)
  } catch (err) {
    return false
  }
}
export const logoPlaceHolder =
  'https://firebasestorage.googleapis.com/v0/b/lotteryd.appspot.com/o/tokens%2Fubet.png?alt=media&token=78f6010c-d43b-4c99-9ff6-d55bf2975350'
export const poolsPagePage = parseInt(process.env.REACT_APP_POOL_PER_PAGE)
export const getTokenURL = 'https://launch.youbet.tech/#/pools/0'
export const viewTranscationURL =
  parseInt(process.env.REACT_APP_CHAIN_ID) === 42
    ? 'https://kovan.etherscan.io/tx/'
    : 'https://etherscan.io/tx/'
